import axios from "axios";
import config from "../config";

const apiGet = async (url, token) => {
  return axios.get(`${config.API_URL}${url}`);
};

const apiPost = async (url, form) => {
  return axios.post(`${config.API_URL}${url}`, form);
};

const apiDelete = async (url) => {
  return axios.delete(`${config.API_URL}${url}`);
};

export const getAllWithAccountNumber = async () => {
  const url = `employee/GetWithAccountNumber`;
  return apiGet(url);
};


export const getEmployeesFromMyHR = async (query) => {
  const url = `employee/GetEmployeeFromMyHR?query=${encodeURIComponent(query)}`;
  const response = await apiGet(url);
  
  return response.data.map(employee => ({
    label: `${employee.firstName} ${employee.lastName} (${employee.email})`,
    value: employee.userId,
    data: {
      userId: employee.userId,
      firstName: employee.firstName,
      lastName: employee.lastName,
      email: employee.email,
      privateEmail: employee.privateEmail,
      privatePhone: employee.privatePhone,
      address1: employee.address1,
      address2: employee.address2,
      city: employee.city,
      zipCode: employee.zipCode,
      country: employee.country
    }
  }));
};

export const submitRequest = async (request) => {
  const url = `request`;
  const data = new window.FormData();
  
  // Map to RequestModel DTO fields
  data.append("email", request.employeePrivateEmail || "");
  const contactEmail = request.sendFormLinkTo === "business"
    ? (request.employeeEmail || "")
    : (request.employeePrivateEmail || "");
  data.append("requestContactEmail", contactEmail);
  data.append("businessEmail", request.employeeEmail || "");
  data.append("firstName", request.employeeFirstName);
  data.append("lastName", request.employeeLastName);
  data.append("country", request.country || "");
  data.append("address1", request.employeeAddressLine1 || "");
  data.append("address2", request.employeeAddressLine2 || "");
  data.append("zipCode", request.employeeZipCode || "");
  data.append("city", request.employeeCity || "");
  
  // Contact mobile (private) and business mobile saved independently
  if (request.mobilePhone) {
    data.append("contactMobile", request.mobilePhone);
  }
  if (request.mobileCountryCallingCode != null) {
    data.append("contactMobileCountryCallingCode", request.mobileCountryCallingCode);
  }
  if (request.businessPhone) {
    data.append("businessMobile", request.businessPhone);
  }
  
  // Approval and notification
  data.append("lineManager", request.lineManager);
  data.append("financeApprover", request.financeApprover);
  data.append("additionalEmail", request.additionalEmail || "");
  data.append("vendorPassCodeByEmail", request.vendorPassCodeByEmail);
  
  // Employee/Account info
  data.append("myHRId", request.myhrid || "");
  data.append("accountName", request.accountName || "");
  data.append("accountNumber", request.accountNumber || "");
  if (request.currencyId != null) {
    data.append("currencyId", request.currencyId);
  }
  
  // File attachment
  
  return axios.post(`${config.API_URL}${url}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getMyRequests = () => 
  apiGet("request/my");

const getFinanceApproverUsers = async () =>
  await apiGet("permission/FinanceApprover");
export const financeApproverDataLoader = {
  loader: async () => await getFinanceApproverUsers(),
  uniqueKey: "getFinanceApproverUsers",
};

const getLineManagerUsers = async () => await apiGet("permission/LineManager");
export const lineManagerDataLoader = {
  loader: async () => await getLineManagerUsers(),
  uniqueKey: "getLineManagerUsers",
};

// export const getAccounts = async (q) =>
//   apiGet(`AccountSearch/GetAccounts/${q}`);


export const apiSendRemainder = async (id) => {
  return apiPost(`request/sendreminder`, { id: id });
};

export const cancelRequest = async (requestId, reason) => {
  const data = {
    Id: parseInt(requestId, 10),
    Reason: reason,
  };


  return apiPost(`request/CancelRequest/`, data);
};

export const sendBackToEmployee = async (requestId, reason) => {
  const data = {
    Id: parseInt(requestId, 10),
    Reason: reason,
  };
  return apiPost(`request/sendBackToEmployee`, data);
};

export const apiReopenRequest = async (requestId, reason) => {
  const data = {
    Id: parseInt(requestId, 10),
    Reason: reason,
  };
  return apiPost(`request/reopen`, data);
};

export const apiGetRequest = async (id) => {
  const url = `request/${id}`;
  return apiGet(url);
};

export const validateRequest = async (id) => {
  const url = `approval/ValidateRequest`;
  return apiPost(url, {
    Id: id,
  });
};

export const changeLineManagerApprover = async (id, email) => {
  const url = `approval/ChangeLineManager`;
  return apiPost(url, {
    Id: id,
    NewApproverEmail: email,
  });
};

export const changeFinanceApprover = async (id, email) => {
  const url = `approval/ChangeFinanceApprover`;
  return apiPost(url, {
    Id: id,
    ApproverEmail: email,
  });
};

export const changeContactEmail = async (id, email) => {
  const url = `request/ChangeContactEmail`;
  return apiPost(url, {
    Id: id,
    ContactEmail: email,
  });
};

export const changeContactMobile = async (id, mobile) => {
  const url = `request/ChangeContactMobile`;
  return apiPost(url, {
    Id: id,
    ContactMobile: mobile,
  });
};

export const getcountryList = async () => 
  apiGet(`employee/GetCountryList`);

export const apiGetCurrencies = async () =>
  apiGet(`employee/GetCurrencies`);

export const getMyHRStatus = async(requestId) => {
  const url = `request/getmyhrstatus?requestId=${requestId}`;
  return apiGet(url);
};

export const apiDeleteFile = async (token, fileName) => {
  return axios.delete(`${config.API_URL}file/RemoveFileAttachment/${fileName}`, {
    headers: { 
      "X-API-KEY": token
    }
  });
};

export const apiPostFiles = async (form) => {
  return apiPost(`file/AddFileAttachment`, form);
};
